module.exports = fox._r("images/press/press-header-bg.jpg", __webpack_public_path__ + "_/common/images/press/press-header-bg.jpg");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/press-header-bg.jpg
// module id = 366
// module chunks = 2